import { render } from "./CldrValue.vue?vue&type=template&id=b9c96556&scoped=true"
import script from "./CldrValue.vue?vue&type=script&lang=js"
export * from "./CldrValue.vue?vue&type=script&lang=js"

import "./CldrValue.vue?vue&type=style&index=0&id=b9c96556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c96556"]])

export default __exports__